import * as React from 'react';
import {Grid, Tab, Tabs as TabsMui} from '@mui/material';

interface Props {
  id?: string;
  type?: 'scrollable';
  value?: number;
  tab:{
    caption: string,
  }[];
  getTabIndex?: (index: number) => void;
}


export const Tabs: React.FunctionComponent<Props> = (props) => {  
  const [value, setValue] = React.useState(props.value || 0);

  const onChange = (e: React.SyntheticEvent<Element, Event>, newValue: number) => {
    setValue(newValue);
    props.getTabIndex?.(newValue);
  }
  
  React.useEffect(() => {
    setValue(props.value || 0)
  }, [props.value])

  return(
    <Grid id={props.id} sx={{maxWidth: {xs: 400 }}} >
      <TabsMui variant={props.type || 'scrollable'} value={value} scrollButtons onChange={onChange}>
          {props.tab?.map((d, i) => {
            return  <Tab key={i} label={d.caption} sx={{textTransform: 'none'}}/>
        })}
      </TabsMui>
    </Grid>
  )
}